import styled from 'styled-components'

import { BodyL } from '~ui'

export const Amount = styled(BodyL).attrs({ $bold: true })`
  margin-left: 10px;
  color: ${({ theme }) => theme.colors.white};
`
